import { toGeoJson } from 'Services/model/traffic/incidentDetails';

export const incidentDetailsResponseMerger = (responses) => {
    const poi = [];
    const preserveCluster = true;
    responses.forEach(response => {
        poi.push(...response.tm.poi);
    });

    const result = {
        tm: {
            poi
        }
    };

    return {
        toGeoJson: () => toGeoJson(result, preserveCluster),
        ...result
    };
};



// WEBPACK FOOTER //
// ./map/tier/incidentDetailsResponseMerger.js